import * as api from '../api';
import * as actionTypes from './types';
import { SubmissionError } from 'redux-form';
import uuid from 'helpers/uuid';
import { getInitialTime, setInitialTime } from 'helpers/login';

export const login =
  (email, password, recaptchaToken, verificationCode, codeMode, mdn) =>
  (dispatch) => {
    const uuidKey = '__device_uuid';
    let deviceUuid = window.localStorage.getItem(uuidKey);

    if (!deviceUuid) {
      deviceUuid = uuid();
      window.localStorage.setItem(uuidKey, deviceUuid);
    }

    dispatch({
      type: actionTypes.LOGIN_PENDING,
      response: null,
    });

    return api
      .requestLogin(
        email,
        password,
        recaptchaToken,
        deviceUuid,
        verificationCode,
        codeMode,
        mdn,
      )
      .then((response) => {
        if (response.data && response.data.status === '2fa_code_sent') {
          const initialTime = getInitialTime(email, mdn);
          if (!initialTime) {
            setInitialTime(email, mdn);
          }
          const defaultTimerTime = 600;
          const timerTime = initialTime || defaultTimerTime;

          return { needCode: true, timerTime };
        }
        return api.fetchLoggedInUser();
      })
      .then((response) => {
        if (response.needCode) {
          return response;
        } else {
          dispatch({
            type: actionTypes.LOGIN_SUCCESS,
            response: response.data,
          });
        }
      })
      .catch((err) => {
        const { response } = err;
        if (
          response &&
          response.status === 400 &&
          response.data &&
          response.data.code_sending_mode
        ) {
          return { selectCodeMode: true };
        }
        let messages = err.response
          ? err.response.data
          : { detail: 'Something went wrong' };
        dispatch({
          type: actionTypes.LOGIN_FAILED,
        });
        throw new SubmissionError(messages);
      });
  };

export const loginCheck = () => (dispatch) => {
  return api
    .fetchLoggedInUser()
    .then((response) => {
      dispatch({
        type: actionTypes.LOGIN_SUCCESS,
        response: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LOGIN_FAILED,
        response: error.response && error.response.data,
      });
    });
};

export const logout = () => (dispatch) => {
  return api
    .logout()
    .then((response) => {
      dispatch({
        type: actionTypes.LOGOUT,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LOGOUT,
      });
    });
};
